export function useUrl() {
  function getParameterFromUrl(parameter: string): string | null {
    const queryString = window.location.search;
    const urlParameters = new URLSearchParams(queryString);
    return urlParameters.get(parameter);
  }

  function removeParameterFromUrl(parameter: string): void {
    const url = new URL(window.location.href);
    url.searchParams.delete(parameter);

    window.history.pushState('object', location.search, url.href);
  }

  return {
    getParameterFromUrl,
    removeParameterFromUrl,
  };
}
